import { render, staticRenderFns } from "./CtaButton.vue?vue&type=template&id=263cd8d8&scoped=true"
import script from "./CtaButton.vue?vue&type=script&lang=js"
export * from "./CtaButton.vue?vue&type=script&lang=js"
import style0 from "./CtaButton.vue?vue&type=style&index=0&id=263cd8d8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263cd8d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('263cd8d8')) {
      api.createRecord('263cd8d8', component.options)
    } else {
      api.reload('263cd8d8', component.options)
    }
    module.hot.accept("./CtaButton.vue?vue&type=template&id=263cd8d8&scoped=true", function () {
      api.rerender('263cd8d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/CtaButton.vue"
export default component.exports